import { Component, OnInit, Input } from '@angular/core';
import { ICabinDeparture } from "app/cabins/cabins.interfaces";
import { CabinsCategoryGroupComponent } from "app/cabins/cabins-category-group/cabins-category-group.component";
import { GridComponent, GridBody, GridHeader } from "app/shared/grid/grid.component";
import { NgForm, FormGroup, FormBuilder, FormControl, Validators, FormArray } from '@angular/forms'

@Component({
    selector: 'sbw-cabins-selector',
    templateUrl: './cabins-selector.component.html',
    styleUrls: ['./cabins-selector.component.css']
})
export class CabinsSelectorComponent implements OnInit {

    @Input() formDepartureGroup: FormGroup;
    @Input() formSelections: FormGroup;
    @Input() content: any;

    get departure(): ICabinDeparture {
        return <ICabinDeparture>this.formDepartureGroup.value
    }

    constructor() { }

    ngOnInit() {}

}
